const monYear = (d)=>d.toLocaleDateString('en-US', {
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    });
const year = (d)=>String(d.getUTCFullYear());
/**
 * Career row date (DAT-07 read contract, OD-100):
 *   stated   → "2019 – 2024" / "2024 – now"
 *   observed → "seen since Mar 2023" (+ " – Jun 2024" once closed)
 *   inferred → "from Mar 2023 (inferred)"
 *   unknown or no dates → "Dates unknown"
 */ export function careerDateLabel(span) {
    switch(span.dateBasis){
        case 'stated':
            if (!span.startDate) return 'Dates unknown';
            return `${year(span.startDate)} – ${span.endDate ? year(span.endDate) : 'now'}`;
        case 'observed':
            {
                const from = span.observedFrom ?? span.startDate;
                if (!from) return 'Dates unknown';
                const to = span.observedTo ?? span.endDate;
                return `seen since ${monYear(from)}${to ? ` – ${monYear(to)}` : ''}`;
            }
        case 'inferred':
            {
                const from = span.startDate ?? span.observedFrom;
                return from ? `from ${monYear(from)} (inferred)` : 'Dates unknown';
            }
        default:
            return 'Dates unknown';
    }
}
